import { useEffect, useRef, useState } from 'react';
import type { FieldType } from '../../types/generator-config';
import { ALL_FIELD_TYPES, iconForType, labelForType } from '../../lib/fieldFactory';
import { Icon } from '../Icon';

interface AddFieldMenuProps {
    onAdd: (type: FieldType) => void;
}

export function AddFieldMenu({ onAdd }: AddFieldMenuProps) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        const onClick = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', onClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    return (
        <div className="add-field" ref={rootRef}>
            <button
                type="button"
                className="add-field-btn"
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
                aria-haspopup="menu"
            >
                <Icon name="plus" size={14} strokeWidth={2.4} />
                Ajouter un champ
            </button>

            {open && (
                <div className="add-field-menu" role="menu">
                    {ALL_FIELD_TYPES.map((t) => (
                        <button
                            key={t}
                            type="button"
                            role="menuitem"
                            className="add-field-item"
                            onClick={() => {
                                onAdd(t);
                                setOpen(false);
                            }}
                        >
                            <span className="add-field-icon" aria-hidden>
                                <Icon name={iconForType(t)} size={18} />
                            </span>
                            <span className="add-field-label">{labelForType(t)}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
